import React from 'react';
import { useNavigate } from 'react-router-dom';

type Step = 'getting-started' | 'incident' | 'damages' | 'additional-info';

interface ProgressStepsProps {
  currentStep: Step;
  hide?: boolean;
}

const ProgressSteps: React.FC<ProgressStepsProps> = ({ currentStep, hide = false }) => {
  const navigate = useNavigate();

  if (hide) {
    return null;
  }

  const steps = [
    { id: 'getting-started' as Step, label: '1. Getting Started', mobileLabel: 'Contact', path: '/' },
    { id: 'incident' as Step, label: '2. Incident', mobileLabel: 'Incident', path: '/incident' },
    { id: 'damages' as Step, label: '3. Inventory', mobileLabel: 'Inventory', path: '/damages' },
  ];

  const getCurrentStepIndex = () => {
    return steps.findIndex(step => step.id === currentStep);
  };

  const currentStepIndex = getCurrentStepIndex();

  const handleStepClick = (step: typeof steps[0], index: number) => {
    if (index < steps.length) {
      // Pass state to prevent form reset when navigating from progress steps
      navigate(step.path, { state: { fromProgressSteps: true } });
    }
  };

  return (
    <div className="progress-indicator">
      {steps.map((step, index) => {
        const isActive = index <= currentStepIndex;
        const isClickable = index < steps.length;

        return (
          <React.Fragment key={step.id}>
            <div
              className={`progress-step ${isActive ? 'active' : ''} ${isClickable ? 'clickable' : ''}`}
              onClick={() => isClickable && handleStepClick(step, index)}
            >
              <span className="progress-step-label progress-step-label--desktop">{step.label}</span>
              <span className="progress-step-label progress-step-label--mobile">{step.mobileLabel}</span>
            </div>
            {index < steps.length - 1 && <div className="progress-line"></div>}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressSteps;

